import { render, staticRenderFns } from "./Reglas.vue?vue&type=template&id=91a8a646&"
import script from "./Reglas.vue?vue&type=script&lang=js&"
export * from "./Reglas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports